module.exports = __webpack_public_path__ + "img/small-yellow-and-green-circles.34680df4.svg";